import { render, staticRenderFns } from "./AddCPage.vue?vue&type=template&id=f5c6369e&"
import script from "./AddCPage.vue?vue&type=script&lang=js&"
export * from "./AddCPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports